import type {
  SUBJECT_ORG_ONBOARDING,
  TUTORIAL_NAME_POST,
  TUTORIAL_NAME_SEARCH,
  TUTORIAL_NAME_TOPIC,
} from '../constants/onboarding';
import {
  ONBOARDING_DATA_SET,
  ONBOARDING_TUTORIAL_ACTIVE_SET,
  ONBOARDING_TUTORIAL_BEACONS_SET,
} from '../constants/redux';
import { persistReducer } from '../utils/persistRedux';

type TutorialName =
  | typeof TUTORIAL_NAME_TOPIC
  | typeof TUTORIAL_NAME_POST
  | typeof TUTORIAL_NAME_SEARCH;

type OnboardingSubject = typeof SUBJECT_ORG_ONBOARDING | TutorialName;

export interface Onboarding {
  subject: OnboardingSubject;
  step: number;
  completedAt: string | null;
  skippedAt: string | null;
}

interface OnboardingActiveBeacons {
  [id: string]: boolean | undefined;
}

export interface OnboardingState {
  activeBeacons: OnboardingActiveBeacons;
  activeTutorial: TutorialName | null;
  data: {
    [SUBJECT_ORG_ONBOARDING]?: Onboarding;
    [TUTORIAL_NAME_TOPIC]?: Onboarding;
    [TUTORIAL_NAME_POST]?: Onboarding;
    [TUTORIAL_NAME_SEARCH]?: Onboarding;
  };
}

const initialState: OnboardingState = {
  activeBeacons: {},
  activeTutorial: null,
  data: {},
};

// TODO: export from namespaces fall within that rule, remove once namespace is changed
/* eslint-disable import/no-unused-modules */

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-namespace
namespace Actions {
  export interface ONBOARDING_TUTORIAL_ACTIVE_SET {
    type: typeof ONBOARDING_TUTORIAL_ACTIVE_SET;
    name: string;
  }

  export interface ONBOARDING_TUTORIAL_BEACONS_SET {
    type: typeof ONBOARDING_TUTORIAL_BEACONS_SET;
    ids: string[] | undefined;
  }

  export interface ONBOARDING_DATA_SET {
    type: typeof ONBOARDING_DATA_SET;
    onboarding: { subject: string };
  }

  export interface OTHER {
    type?: undefined;
  }

  export type ANY =
    | ONBOARDING_TUTORIAL_ACTIVE_SET
    | ONBOARDING_TUTORIAL_BEACONS_SET
    | ONBOARDING_DATA_SET
    | OTHER;
}

function onboardingReducer(
  state = initialState,
  action: Actions.ANY = {},
): OnboardingState {
  switch (action.type) {
    case ONBOARDING_TUTORIAL_ACTIVE_SET:
      return {
        ...state,
        // @ts-expect-error Need to add tutorial name type to reducer
        activeTutorial: action.name,
      };
    case ONBOARDING_TUTORIAL_BEACONS_SET:
      return {
        ...state,
        activeBeacons: action.ids
          ? action.ids.reduce((memo, id) => {
              // eslint-disable-next-line no-param-reassign
              memo[id] = true;
              return memo;
            }, {} as OnboardingActiveBeacons)
          : {},
      };
    case ONBOARDING_DATA_SET:
      return {
        ...state,
        data: {
          ...state.data,
          [action.onboarding.subject]: action.onboarding,
        },
      };
    default:
      return state;
  }
}

export default persistReducer(
  {
    key: 'onboarding',
    whitelist: ['data'],
  },
  onboardingReducer,
);
